import { useState } from "react";
import { useDispatch } from "react-redux";
// import ReactGA from "react-ga4";
import { toast } from "react-toastify";
import { useCurrentUser } from "utils/hooks";
import { fetchResourcesStatsAction } from "store/actions/reports";
import { ORGANIZATION_USER_ROLES } from "utils/constants";

type FetchResourceStatsArgs = {
  resourceType: string;
  userId: Array<any>;
  startDate: string;
  endDate: string;
};

const useFetchResourceStats = () => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();
  const [loading, setLoading] = useState(false);

  const fetchResourceStats = async (
    args: FetchResourceStatsArgs
  ): Promise<void> => {
    if (!args || !user) {
      return;
    }

    setLoading(true);

    const userIds: Array<string> = [];
    const userRoles: Array<string> = [];
    const roles = [
      ORGANIZATION_USER_ROLES.MEMBER,
      ORGANIZATION_USER_ROLES.INTERN,
    ];

    args?.userId?.map((u) => {
      if (roles.includes(u.value)) {
        userRoles.push(`"${u.value}"`);
      } else {
        userIds.push(`"${u.value}"`);
      }
      if (u.value === ORGANIZATION_USER_ROLES.MEMBER) {
        userRoles.push(`"${ORGANIZATION_USER_ROLES.OWNER}"`);
      }
    });

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            mutation {
              getResourceStats(filters: {
                resourceType: "${args.resourceType}",
                userRole: [${userRoles}],
                userId: [${userIds}],
                startDate: "${args.startDate}",
                endDate: "${args.endDate}",
              }) {
                  uuid
                  organizationId
                  resourceId
                  assignmentType
                  patientId
                  actionStatus
                  assigned_by
                  assigned_by_role
                  assigned_at
                  hasNotification
                  notificationId
                  createdAt
                  resourceType
                  patient_name
                  group_name
                  resource_name
                }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user.activeOrganizationId || "NA",
          permissionKey: "update_patients",
        },
      });

      if (res.status !== 200 && res.status !== 201) {
        toast.error("Hmm, something went wrong.");
      }

      const resData = await res.json();

      if (resData.errors) {
        toast.error(`${resData.errors[0].message}`);
        return;
      }

      if (resData.data.getResourceStats) {
        dispatch(fetchResourcesStatsAction(resData.data.getResourceStats));
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return { fetchResourceStats, loading };
};

export default useFetchResourceStats;
